import { combineEpics } from 'redux-observable'
import { GetProjectEpic } from './GetProjectEpic.js'
import { GetAllProjectsEpic } from './GetAllProjectsEpic.js'
import { CreateProjectEpic } from './CreateProjectEpic.js'
import { GetParticipantsEpic } from './GetParticipantsEpic.js'
import { UpdateProjectEpic } from './UpdateProjectEpic.js'
import { AddProjectSamplesEpic } from './AddProjectSamplesEpic.js'
import { DeleteProjectSamplesEpic } from './DeleteProjectSamplesEpic.js'
import { DeleteMultipleProjectSamplesEpic } from './DeleteMultipleProjectSamplesEpic.js'
import { GetProjectSamplesEpic } from './GetProjectSamplesEpic.js'
import { GetNotesEpic } from './GetNotesEpic.js'
import { AddNoteEpic } from './AddNoteEpic.js'
import { DeleteNoteEpic } from './DeleteNoteEpic.js'
import { UpdateNoteEpic } from './UpdateNoteEpic.js'
import { GetOtuProcessIdsEpic } from './GetOtuProcessIdsEpic.js'
import { DeleteProjectEpic } from './DeleteProjectEpic.js'
import { InviteProjectParticipantEpic } from './InviteProjectParticipantEpic.js'
import { AcceptProjectInviteEpic } from './AcceptProjectInviteEpic.js'
import { UpdateParticipantEpic } from './UpdateParticipantEpic.js'
import { DeleteParticipantEpic } from './DeleteParticipantEpic.js'
import { ProjectBatchUpdateSamplesEpic } from './ProjectBatchUpdateSamplesEpic.js'
import { ToggleDraftModeEpic } from './ToggleDraftModeEpic.js'
import { GetReportEpic } from '../Order/GetReportEpic/GetReportEpic.js'
import { GetProjectOrdersEpic } from './GetProjectOrdersEpic.js'
import { HandleProjectLockChangedEpic } from './HandleProjectLockChangedEpic.js'

export const projectEpics = combineEpics(
  GetProjectEpic,
  GetAllProjectsEpic,
  CreateProjectEpic,
  GetParticipantsEpic,
  UpdateProjectEpic,
  AddProjectSamplesEpic,
  DeleteProjectSamplesEpic,
  DeleteMultipleProjectSamplesEpic,
  GetProjectSamplesEpic,
  GetNotesEpic,
  AddNoteEpic,
  DeleteNoteEpic,
  UpdateNoteEpic,
  GetOtuProcessIdsEpic,
  DeleteProjectEpic,
  InviteProjectParticipantEpic,
  AcceptProjectInviteEpic,
  UpdateParticipantEpic,
  DeleteParticipantEpic,
  ProjectBatchUpdateSamplesEpic,
  ToggleDraftModeEpic,
  GetReportEpic,
  GetProjectOrdersEpic,
  HandleProjectLockChangedEpic
)
